import { styled } from '@mui/material';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';

export { Radio, RadioGroup };

export const TaStyledRadio = styled(Radio)(({ theme }) => ({
  '&.Mui-checked': {
    color: theme.colors.primary.main,
    '& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root) path': {
      stroke: theme.colors.primary.main,
      color: theme.colors.primary.main,
    },
  },

  '& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)': {
    color: theme.colors.secondary.border,
  },

  '& .MuiSvgIcon-root + .MuiSvgIcon-root': {
    color: theme.colors.primary.main,
  },
}));
